export const mapCategories = (categories: string): Array<string> => {
  return categories.split('. ');
};
